import { gql, useMutation } from "@apollo/client";

const GENERATE_BEFORE_AND_AFTER_SHARE_TOKEN = gql`
  mutation GenerateBeforeAndAfterShareToken($projectId: ID!) {
    generateBeforeAndAfterShareToken(projectId: $projectId) {
      _id
      shareToken
    }
  }
`;

export const useGenerateBeforeAndAfterShareTokenMutation = () => {
  const [generateShareToken, { loading, error }] = useMutation(
    GENERATE_BEFORE_AND_AFTER_SHARE_TOKEN
  );

  return {
    generateShareToken,
    loading,
    error,
  };
};























